import { FormGroup, FormArray, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { Component, Inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomValidator } from 'src/app/shared/services/custom-validator.service';
@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {
  reg = /[^a-zA-Z0-9-_@#$%&().'"=\s]/;
  filterGroup: FormGroup;
  filterControls: FormArray;
  filterSettings = [];
  filterType = [];
  orderTypes = [];
  fieldType = {};
  status = [];
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data,
    private formBuilder: FormBuilder,
    private _api: ApiService,
    private _util: UtilitiesService,
    private spinner: NgxSpinnerService,
    private ref: ChangeDetectorRef,
    private _validator: CustomValidator
  ) {
    this.filterGroup = this.formBuilder.group({
      filterControls: this.formBuilder.array([this.createFilterForm()])
    });
  }
  createFilterForm(Data?: any): FormGroup {
     return this.formBuilder.group({
      coloumnName: new FormControl(Data ? Data.coloumnName : '', Validators.required)
      , filter: new FormControl(Data ? Data.filter : '')
      , counterParty: new FormControl(Data ? Data.counterParty : '')
      , filtervalue: new FormControl(Data ? Data.filtervalue : '')
      , fromDate: new FormControl(Data ? Data.fromDate : '')
      , toDate: new FormControl(Data ? Data.toDate : '')
      , status: new FormControl(Data ? Data.status : '')
    });
  }
  savePreset() {
    const apiObj = {
      pref_name: this.data['page']
      , pref_key: 'FILTER'
      , pref_value: JSON.stringify(this.getApiObj())
    };
    this._api.functionPOST('user/updatePreference', apiObj).subscribe((response) => {
      if (response['success']) {
        this._api.openSnackBar('Applied Filter Successfully', 'Success');
      }
    });
  }
  removePreset() {
    const apiObj = {
      pref_name: this.data['page']
      , pref_key: 'FILTER'
    };

    this._api.functionPOST('user/deletePreference', apiObj).subscribe((response) => {
      if (response['success']) {
        // this._api.openSnackBar(response['data'], 'Success');
        this.dialogRef.close({ filter: [] });
        // this.resetForm();
        // setTimeout(() => {
        //   this.resetFilter();
        // }, 1000);
      }
    });
  }
  setFilterType($event, index, isPatch?) { 

     const formGrup = this.filterGroup.get('filterControls');
     const formRow = formGrup['controls'][index] as FormGroup;
     const valueCtrl = formRow.get('filtervalue');
    // const valueCtrl = '';
    const operatorCtrl = formRow.get('filter');
    const counterPartyCtrl = formRow.get('counterParty');
    const statusCtrl = formRow.get('status');

    const result = this.filterGroup.value;
    let count = 0;
    this.filterType[index] = $event.value['operator'];
    this.orderTypes[index] = $event.value['counterParty'] ? $event.value['counterParty'] : [];
    this.status[index] = $event.value['status'] ? $event.value['status'] : [];
    result['filterControls'].map((x) => {
      if (x.coloumnName['value'] && x.coloumnName['value'] === $event['value']['value']) {
        count++;
      }
    });
    if (count > 1) {
      formRow.patchValue({
        coloumnName: ''
      });
      this._api.openSnackBar('Can\'t Duplicate Filter', 'Error');
      return;
    }
    const clearValidators = (control: AbstractControl) => {
      control.clearValidators();
      control.updateValueAndValidity();
    };
    const setDefaultOperator = () => {
      if (!isPatch) {
        setTimeout(() => {
          operatorCtrl.setValue(this.filterType[index].length !== 0 ? this.filterType[index][0].value : '');
          valueCtrl.setValue('')
        });
      }
    };
    const keyType = $event['value']['type'];
     switch (keyType) {
      case 'Date': 
        this.fieldType[index] = 1;
        clearValidators(valueCtrl);
        clearValidators(operatorCtrl);
        clearValidators(statusCtrl);
        break;

      case 'Status': 
        this.fieldType[index] = 3;
        statusCtrl.setValidators(Validators.required);
        operatorCtrl.setValidators(Validators.required);
        setDefaultOperator();
        clearValidators(valueCtrl);
        break;

      default: 
        this.fieldType[index] = 0;
        valueCtrl.setValidators([Validators.required, this._validator.isFullSpace]);
        operatorCtrl.setValidators(Validators.required);
        setDefaultOperator();
        clearValidators(statusCtrl);
        statusCtrl.setValidators(Validators.required);
        clearValidators(valueCtrl);
        break;
    }
    valueCtrl.updateValueAndValidity();
    operatorCtrl.updateValueAndValidity();
    if (isPatch) {
      setTimeout(() => {
        this.ref.markForCheck();
      });
    }
  }
  resetFilter() {
    this.removePreset();
    // this.dialogRef.close([]);
  }
  getApiObj() {
     const result = this.filterGroup.value;
    const flArray = [];
    let obj = {};
    result['filterControls'].map((x) => {
      switch (x.coloumnName['type']) {
        case 'Date':
          const DateFromKey = x.coloumnName.dateFrom;
          const DateToKey = x.coloumnName.dateTo;
          const DateFromVal = x.fromDate;
          const DateToVal = x.toDate;
          if (!isNaN(Date.parse(DateFromVal))) {

            const objDateFrom = {
              key: DateFromKey
              , operator: '>='
              , value: this._util.formatDate(DateFromVal, 'yyyy-mm-dd')
            };
            flArray.push(objDateFrom);
          }
          if (!isNaN(Date.parse(DateToVal))) {

            const objDateTo = {
              key: DateToKey
              , operator: '<='
              , value: this._util.formatDate(DateToVal, 'yyyy-mm-dd')
            };
            flArray.push(objDateTo);
          }
          break;
        case 'Status':
          obj = {
            key: x.coloumnName['value']
            , operator: x.filter
            , value: x.status
          };
          flArray.push(obj);
          break;
        case 'CounterParty':
          obj = {
            key: x.coloumnName['value']
            , operator: x.filter
            , value: x.counterParty
          };
          flArray.push(obj);
          break;
        default:
          obj = {
            key: x.coloumnName['value']
            , operator: x.filter
            , value: x.filtervalue.trim()
          };
          flArray.push(obj);
          break;
      }
    });
    return flArray;
  }
  applyFilter() {
   
      const validDate = this.filterGroup.value.filterControls
      .some(x => x.coloumnName.type === 'Date' && x.toDate === '' && x.fromDate === '');
     const acNoValidate = this.filterGroup.value.filterControls
     .some(x => x.coloumnName.value === 'account_no' && isNaN(x.filtervalue));
 
    if (this.filterGroup.invalid || validDate || acNoValidate) {
      this._api.openSnackBar('Please enter valid details', 'Error');
      return;
    }
    let check = false;
    this.filterGroup.value.filterControls.forEach(el =>{
      const areThereAnyCommas = el.filtervalue.includes(',');
      if(areThereAnyCommas){
        this._api.openSnackBar('Please enter valid value without comma', 'Error');
         check = true;
      }
    })
   
    const obj = {
      filter: this.getApiObj()
      , filterForm: this.filterGroup.value

    };
    if(!check){
      this.savePreset();

      this.dialogRef.close(obj);
    }
  }

  closeModel(): void {
    this.dialogRef.close();
  }
  addFilter(): void {
    if (this.filterGroup.invalid) {
      this._api.openSnackBar('Please enter valid details', 'Error');
      return;
    }
    this.filterControls = this.filterGroup.get('filterControls') as FormArray;
    this.filterControls.push(this.createFilterForm());
  }
  tempResetForm() {
    const filterControls = this.filterGroup.get('filterControls') as FormArray;
    filterControls['controls'].map((x, i) => {
      if(i!=0 && i!=1){
        filterControls.removeAt(i);
      }
    });
    this.filterControls.push(this.createFilterForm());
    this.filterControls.updateValueAndValidity();
    this.filterGroup.updateValueAndValidity();
  }
  resetForm() {
    const filterControls = this.filterGroup.get('filterControls') as FormArray;
    filterControls['controls'].map((x, i) => {
      filterControls.removeAt(i);
    });
    this.filterControls.push(this.createFilterForm());
    this.filterControls.updateValueAndValidity();
    this.filterGroup.updateValueAndValidity();
  }
  removeFilter(index) {
    const filterControls = this.filterGroup.get('filterControls') as FormArray;
    delete this.fieldType[index];
    filterControls.removeAt(index);
    this.status.splice(index, 1);
    this.orderTypes.splice(index, 1);
    let i = 0;
    const fieldType = {};
    for (const key of Object.keys(this.fieldType)) {
      fieldType[i] = this.fieldType[key];
      i++;
    }
    this.fieldType = fieldType;
    this.filterControls.updateValueAndValidity();
    this.filterGroup.updateValueAndValidity();
  }
  populateData(Data) {
     if (Data) {
      this.filterControls = this.filterGroup.get('filterControls') as FormArray;
      this.removeFilter(0);
      Data.filterControls.map((x, i) => {
        const popObj = {
          coloumnName: this._util.getItemByID(this.data['filterData'], 'value', x.coloumnName.value)
          , filter: x.filter
          , filtervalue: x.filtervalue
          , fromDate: x.fromDate
          , toDate: x.toDate
          , status: x.status
          , counterParty: x.counterParty
        };
        this.filterControls.push(this.createFilterForm(popObj));
        this.setFilterType({ value: popObj.coloumnName }, i, true);
      });
    }
  }

  getPreset() {
    const obj = {
      pref_name: this.data['page'],
      pref_key: 'FILTER'

    };
    const arrayObj = {
      filterControls: []
    };
    const getDate = (date) => {
      const dt = date.split('-');
      const newDate = new Date();
      newDate.setDate(dt[2]);
      newDate.setMonth(dt[1] - 1);
      newDate.setFullYear(dt[0]);
      newDate.setHours(0, 0, 0, 0);
      return newDate;
    }; 
    this.spinner.show();
    this._api.functionPOST('user/getUserFilters', obj).subscribe((response) => {
      this.spinner.hide();
      const responseData = response['data'];
      if (responseData.length > 0) {
        const array = [];
        responseData.map(x => {
          if((x.key).includes('grand_total_amount')){
            array.push(x);
           }else{
            if ((x.key).includes('_from') || (x.key).includes('_to')) {
               const foundArr = responseData.filter(f => f.key.replace(/_from/, '')
                .replace(/_to/, '') === x.key.replace(/_from/, '').replace(/_to/, ''));
              const _to = foundArr.find(t => t.key.includes('_to'));
              const _from = foundArr.find(f => f.key.includes('_from'));
              const filObj = {
                fromDate: _from ? getDate(_from.value) : ''
                , toDate: _to ? getDate(_to.value) : ''
                , key: x.key.replace(/_from/, '').replace(/_to/, '')
                , operator: x.operator
                , value: ''
              };
              const isDup = array.findIndex(t => t.key === filObj.key);
              if (isDup === -1) {
                 array.push(filObj);
              }
             } else {
              array.push(x);
             }
          }
          
        });
         array.map((x) => { 
          const popObj = {
            coloumnName: this._util.getItemByID(this.data['filterData'], 'value', x.key)
            , filter: x.operator
            , filtervalue: x.value
            , fromDate: x.fromDate
            , toDate: x.toDate
            , status: x.value
          };
          arrayObj.filterControls.push(popObj);
        });
        this.populateData(arrayObj);
      }
    });
  }

  ngOnInit() {
    this.filterSettings = this.data['filterData'];
    setTimeout(() => {
      this.getPreset();
    });
  }

}
